import { map, pathOr, filter, includes, equals, not } from 'ramda';
import { getSubProduct } from '../Advisors/Applications/SummaryMortgage/commonContext';

interface LoanProductDetails {
  advisorLoanProducts:[];
  loanProducts: [];
}

export const getAdvisorSubProducts = (
  loanProductDetails: LoanProductDetails
) => {
  //getting subproducts which advisor has access
  const { advisorLoanProducts, loanProducts } = loanProductDetails;
  const subProductToBeFiltered = map(
    (product: any) => pathOr('', ['value'], product),
    advisorLoanProducts
  );
  //getting all the subproducts
  const allLoanSubProducts = getSubProduct(loanProducts);
  //This will filter the subproduct which advisor has access from loan product and filter out inactive products
  const advisorSubProducts = filter((product: any) => {
    return includes(pathOr('', ['name'], product), subProductToBeFiltered) && not(equals(pathOr('false', ['inactive'], product),"true")) ;
  }, allLoanSubProducts);

  return map((product: any) => {
    const name = pathOr('', ['name'], product);
    const aliasname = pathOr('', ['aliasname'], product);
    const description = pathOr('', ['description'], product);
    return { label: name, value: name, aliasname, description };
  }, advisorSubProducts);
};
